import React, { PureComponent } from 'react';
/* eslint-disable */
import { MY_API_URL } from '../QueryMe';
import DownIcon from 'mdi-react/ChevronDownIcon';
import { Collapse } from 'reactstrap';
import TopbarMenuLink from './TopbarMenuLink';
import ProfileImage from '../../Apanel/ProfileImage';
const apiurl = MY_API_URL;
const dimgurl = apiurl + 'ava.png';
const initialstate = {
	image: localStorage.profile_img,
	collapse: false,
};
export default class TopbarProfile extends PureComponent {
	constructor(props) {
		super(props);
	}
	state = { ...initialstate };

	toggle = () => {
		this.setState((prevState) => ({ collapse: !prevState.collapse }));
	};
	componentDidMount() {
		if (this.state.image) {
			console.log(this.state.image);
		} else {
			this.setState({ image: dimgurl });
			console.log(this.state.image);
		}
	}
	render() {
		const { collapse } = this.state;

		return (
			<div className="topbar__profile">
				<button type="button" className="topbar__avatar" onClick={this.toggle}>
					<ProfileImage clname="topbar__avatar-img" flpath={this.state.image} />
					<p className="topbar__avatar-name">{localStorage.name}</p>
					<DownIcon className="topbar__icon" />
				</button>
				{collapse && (
					<button
						type="button"
						className="topbar__back"
						onClick={this.toggle}
					/>
				)}
				<Collapse isOpen={collapse} className="topbar__menu-wrap">
					<div className="topbar__menu" onClick={this.toggle}>
						<TopbarMenuLink title="Profile" icon="list" path="/profile" />
						<div className="topbar__menu-divider" />
						<TopbarMenuLink title="Tickets" icon="list" path="/mytickets" />
						<div className="topbar__menu-divider" />
						<TopbarMenuLink title="Log Out" icon="exit" path="/logout" />
					</div>
				</Collapse>
			</div>
		);
	}
}
